import React, { useEffect, useState } from "react";
import { Card, CardBody, CardFooter, Col, FormGroup, ListGroup, ListGroupItem, Row, Button, CardTitle } from "reactstrap";
import { UserPlus, Copy } from "react-feather";
import { toast } from "react-toastify";

import useFetcher from "../../hooks/useFetcher";
import { handleErrors } from "../../services/handleErrors";
import { StyledSelect } from "../../components/StyledSelect";
import { getPisPermisoCarpeta, fetchFolderById, sharedFolder, deleteSharedFolder, generateShareLink } from "../../services/fileManagerService";
import { BlurSpinner } from "../../components/BlurSpinner";

const ShareFolder = ({ selected }) => {
  const { id } = selected;
  const [folderData, isLoadingFolderData] = useFetcher(fetchFolderById, [{ entityId: id }]);
  const [pisFolder, isLoadingPis] = useFetcher(getPisPermisoCarpeta, [{ entityId: selected.id }]);
  const [piSelectedDefault, setPiSelectedDefault] = useState([]);
  const [piSelected, setPiSelected] = useState([]);

  const piOptionList = pisFolder
    ? pisFolder
        .map((pis) => {
          return { label: pis.email2, value: pis.itemId, data: pis };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  const piOptionDefaultList = folderData.comparticiones
    ? folderData.comparticiones
        .map((pis) => {
          return { label: pis.email2, value: pis.itemId, data: pis };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  useEffect(() => {
    setPiSelectedDefault([...piOptionDefaultList]);
    setPiSelected([...piOptionDefaultList]);
    return () => {
      setPiSelectedDefault();
    };
  }, [folderData]);

  const actionSharedFolder = async (piId) => {
    try {
      const resp = await sharedFolder({ folderId: id, piId });
      toast.success(resp.message);
    } catch (err) {
      handleErrors(err, toast.error);
    }
  };

  const actionDeleteSharedFolder = async (piId) => {
    try {
      const resp = await deleteSharedFolder({ folderId: id, piId });
      toast.success(resp.message);
    } catch (err) {
      handleErrors(err, toast.error);
    }
  };

  const handlePiOptionChange = (event, metaData) => {
    if (metaData.action) {
      if (metaData.action === "select-option") {
        const piId = metaData.option.value;
        actionSharedFolder(piId);
      }
      if (metaData.action === "remove-value") {
        const piId = metaData.removedValue.value;
        actionDeleteSharedFolder(piId);
      }
    }
    setPiSelected(event);
  };

  const copyToClipboard = (text) => {
    const textField = document.createElement("textarea");
    textField.innerText = text;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand("copy");
    textField.remove();
  };

  const getShareLink = async () => {
    try {
      const resp = await generateShareLink({ folderId: id });
      copyToClipboard(resp.result);
      toast.success("¡Link copiado!");
    } catch (err) {
      handleErrors(err, toast.error);
    }
  };

  return (
    <BlurSpinner isLoading={isLoadingPis || isLoadingFolderData}>
      <Card>
        <CardBody className="m-0 p-0">
          <Row>
            <Col>
              <FormGroup>
                {piSelectedDefault.length > 0 && (
                  <StyledSelect
                    defaultValue={piOptionDefaultList}
                    isMulti
                    id="cliente"
                    name="cliente"
                    placeholder="Añadir personas"
                    onChange={handlePiOptionChange}
                    options={piOptionList}
                    isClearable={false}
                  />
                )}
                {piSelectedDefault.length === 0 && (
                  <StyledSelect
                    isMulti
                    id="cliente"
                    name="cliente"
                    placeholder="Añadir personas"
                    onChange={handlePiOptionChange}
                    options={piOptionList}
                    isClearable={false}
                  />
                )}
                <ListGroup className="my-3">
                  {piSelected.length > 0 &&
                    piSelected.map((pi) => (
                      <ListGroupItem className="py-1" key={pi.data.itemId}>
                        <Row>
                          <Col md="2">
                            <UserPlus size={32} />
                          </Col>
                          <Col>
                            <p className="my-0">{pi.data.nombreApellido}</p>
                            <p>{pi.label}</p>
                          </Col>
                        </Row>
                      </ListGroupItem>
                    ))}
                </ListGroup>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <Card className="mb-0">
        <CardBody className="m-0 p-0">
          <CardTitle tag="h6">Obtener vinculo</CardTitle>
          <p tag="h6" className="mb-3 text-muted">
            Cualquier persona con este link tendra permisos sobre esta carpeta
          </p>
        </CardBody>
        <CardFooter className="mx-0 p-0">
          <Button color="primary" className="float-right" onClick={() => getShareLink()}>
            <Copy /> Copiar vinculo
          </Button>
        </CardFooter>
      </Card>
    </BlurSpinner>
  );
};

export default ShareFolder;
